import React from 'react';
import { ComposableTable, getTextCellGenerator } from 'components/ComposableTable';
import { ParticipantRow } from 'coaching/components/CoachingCoordinatorView/CoachingCoordinatorPeopleListView';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import EventTracking from 'lib/EventTracking';
import Row from 'components/Row';
import ScrollLoadZone from 'components/ScrollLoadZone';

export type Props = {
  loadingParticipants: boolean;
  participants: ParticipantRow[];
  onSelectParticipant: (participant: ParticipantRow) => void;
  onNextPage: () => Promise<void>;
  hasNextPage?: boolean;
  selectedParticipant?: ParticipantRow;
};

function columnHeaders() {
  return [{ name: 'Student name' }, { name: 'Parent name' }, { name: 'Permalink slug' }];
}

function columnGenerators(): Array<(data: ParticipantRow) => React.ReactNode> {
  return [
    getTextCellGenerator('studentName', { weight: 'semibold' }),
    getTextCellGenerator('parentName'),
    getTextCellGenerator('distanceLearningPermalink'),
  ];
}

function trackEvent(event: string) {
  EventTracking.trackKey(`coaching.coordinator_tool.participant_list.${event}`);
}

export default function CoachingCoordinatorParticipantList(props: Props) {
  const { selectedParticipant, participants } = props;

  React.useEffect(() => {
    trackEvent('view');
  }, []);

  return (
    <React.Fragment>
      <Row>
        <ComposableTable<ParticipantRow>
          rows={participants}
          columnHeaders={columnHeaders()}
          columnGenerators={columnGenerators()}
          fixedHeader
          keyField="uuid"
          handleRowClick={participant => {
            trackEvent('participant.click');
            props.onSelectParticipant(participant);
          }}
          keysOfActiveRows={selectedParticipant && [selectedParticipant.uuid]}
        />
      </Row>
      {props.loadingParticipants && <CenteredLoadingIndicator />}
      {props.hasNextPage && <ScrollLoadZone threshold={100} onZoneActivated={props.onNextPage} />}
    </React.Fragment>
  );
}
